'use client';

import React from 'react';
import { clipboard } from '@/utils/funtion';
import Tooltip from '@/components/atoms/tooltip';

function CopyHashtag() {
  return (
    <Tooltip title="Copy Hashtags" placements="top">
      {' '}
      <span
        className="p-news_copy-hashtag"
        onClick={() => {
          clipboard(
            '#DataChallenge #Vietstats #PhanTichDuLieu',
            'Copy thành công',
          );
        }}
      >
        #DataChallenge #Vietstats #PhanTichDuLieu
      </span>
    </Tooltip>
  );
}

export default CopyHashtag;
